module.exports = __webpack_public_path__ + "img/txt.01cec0e1.png";